/* =========================
   Rebuy Smart Cart Gate
   ========================= */

window.EH = window.EH || {};
window.EH.rebuyGate = {
  isBlocking: false,
  pendingOpen: false,
  observer: null,
  armed: false
};

window.EH.requestOpenSmartCart = function () {
  const gate = window.EH.rebuyGate;

  if (gate.isBlocking || gate.armed) {
    gate.pendingOpen = true;
    return;
  }

  if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
    Rebuy.SmartCart.show();
  }
};

window.EH.openSmartCartNow = function () {
  if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
    Rebuy.SmartCart.show();
  }
};

window.EH.blockDrawerForRebuy = function () {
  const gate = window.EH.rebuyGate;
  gate.armed = true;
  gate.isBlocking = true;
  gate.pendingOpen = true;

  // Prevent Smart Cart from auto-opening on add to cart
  if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
    Rebuy.SmartCart.skip_open = true;
  }

  if (gate.observer) {
    try { gate.observer.disconnect(); } catch (e) {}
    gate.observer = null;
  }

  gate.observer = new MutationObserver(() => {});
  gate.observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style", "aria-hidden"]
  });
};

window.EH.unblockDrawerForRebuy = function () {
  const gate = window.EH.rebuyGate;
  gate.isBlocking = false;
  gate.armed = false;
  gate.pendingOpen = false;

  // Re-enable Smart Cart auto-open
  if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
    Rebuy.SmartCart.skip_open = false;
  }

  if (gate.observer) {
    try { gate.observer.disconnect(); } catch (e) {}
    gate.observer = null;
  }
};

window.EH.openThenUnblock = function () {
  // Unblock FIRST so the gate is disarmed (and skip_open reset) before we ask the
  // Smart Cart to open. Otherwise the rebuy:smartcart.show interceptor below would
  // see an armed gate and immediately hide the cart we just opened.
  window.EH.unblockDrawerForRebuy();
  window.EH.openSmartCartNow();
};

// Intercept Smart Cart opening - hide immediately if gate is armed
document.addEventListener("rebuy:smartcart.show", function() {
  const gate = window.EH.rebuyGate;
  if (gate.armed || gate.isBlocking) {
    // Smart Cart tried to open while popup should be showing - hide it
    if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart && typeof Rebuy.SmartCart.hide === 'function') {
      Rebuy.SmartCart.hide();
    }
  }
});

/* =========================
   Arm gate on Add-to-Cart
   ONLY when product is tagged rebuy-upsell
   ========================= */

(function setupATCArm() {
  function shouldGateForForm(formEl) {
    return !!formEl.closest('.product-form[data-has-rebuy-upsell="true"]');
  }

  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute("action") || "").toLowerCase();
      if (!action.includes("/cart/add")) return;

      if (shouldGateForForm(form)) {
        window.EH.blockDrawerForRebuy();
      } else {
        window.EH.unblockDrawerForRebuy();
      }
    },
    true
  );

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(
        'button[name="add"], button[type="submit"], [data-add-to-cart], .product-form__submit'
      );
      if (!btn) return;

      const form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      if (shouldGateForForm(form)) {
        window.EH.blockDrawerForRebuy();
      } else {
        window.EH.unblockDrawerForRebuy();
      }
    },
    true
  );
})();

/* =========================
   Rebuy
   ========================= */

(function setupRebuyLogic() {
  const REBUY_WIDGET_ID = "263114";

  function getWidgetRoot() {
    return document.getElementById(`rebuy-widget-${REBUY_WIDGET_ID}`);
  }

  function isWidgetVisible() {
    const root = getWidgetRoot();
    return !!(root && root.classList.contains("is-visible"));
  }

  function hideSmartCart() {
    if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart && typeof Rebuy.SmartCart.hide === 'function') {
      Rebuy.SmartCart.hide();
    }
  }

  function dismissIfInRebuyFlow() {
    if (window.EH.rebuyGate.armed || window.EH.rebuyGate.isBlocking) {
      window.EH.openThenUnblock();
    }
  }

  // Only suppress the Smart Cart while we're actually in the upsell flow (gate
  // armed). Once the flow ends, a legitimate manual open must not be re-hidden.
  function inRebuyFlow() {
    return window.EH.rebuyGate.armed || window.EH.rebuyGate.isBlocking;
  }

  // When widget 263114 shows, hide the Smart Cart so only the popup is visible
  document.addEventListener("rebuy:widget.show", (event) => {
    const widget = event.detail && event.detail.widget;
    if (widget && String(widget.id) === REBUY_WIDGET_ID && inRebuyFlow()) {
      hideSmartCart();
    }
  });

  // Backup: watch for widget becoming visible via class change
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.id === `rebuy-widget-${REBUY_WIDGET_ID}` && target.classList.contains('is-visible') && inRebuyFlow()) {
          hideSmartCart();
        }
      }
    }
  });

  // Start observing once DOM is ready
  function startObserver() {
    const root = getWidgetRoot();
    if (root) {
      observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    } else {
      // Widget not in DOM yet, wait and retry
      setTimeout(startObserver, 500);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  document.addEventListener("rebuy.add", (event) => {
    const widget = event.detail && event.detail.widget;
    if (widget && String(widget.id) === REBUY_WIDGET_ID) {
      window.EH.openThenUnblock();
    }
  });

  // NOTE: We intentionally do NOT reopen the Smart Cart on `rebuy:smartcart.hide`.
  // While the upsell popup is showing we programmatically hide the Smart Cart, which
  // itself fires `rebuy:smartcart.hide`. Reacting to that here created a feedback
  // loop that reopened the cart (and tore down the gate) on top of the popup.
  // The Smart Cart is opened deliberately instead — when the upsell is added
  // (`rebuy.add`) or when the popup is dismissed (decline / close / backdrop below).

  document.addEventListener(
    "click",
    (e) => {
      const root = getWidgetRoot();
      if (!root) return;

      if (!isWidgetVisible()) return;

      const t = e.target;

      const decline = t.closest("button.rebuy-button.decline");
      if (decline && root.contains(decline)) {
        dismissIfInRebuyFlow();
        return;
      }

      const close = t.closest(".rebuy-modal-close");
      if (close && root.contains(close)) {
        dismissIfInRebuyFlow();
        return;
      }

      const content = root.querySelector(".rebuy-widget-content");
      const clickedInsideContent = content && content.contains(t);

      if (root.contains(t) && !clickedInsideContent) {
        dismissIfInRebuyFlow();
        return;
      }
    },
    true
  );
})();

/* =========================
   Cart Notification
   ========================= */

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    // Bail when handed an error instead of a cart/line item, so we don't open the cart
    // drawer (which locks page scroll) with nothing to show. This covers both a failed
    // raw fetch Response (callers that pass the unparsed response) and a parsed Shopify
    // error object ({status, message}) — e.g. an add rejected with HTTP 422.
    if (parsedState instanceof Response) {
      if (!parsedState.ok) return;
    } else if (parsedState && parsedState.status && (parsedState.message || parsedState.description)) {
      return;
    }
    this.productId = null;
    if(parsedState.hasOwnProperty('id')) {
      this.productId = parsedState.id;
    } else if(parsedState.hasOwnProperty('items') && parsedState.items.length > 0) {
      this.productId = parsedState.items[0].id;
    }
    this.getSectionsToRender().forEach((section => {
      if(parsedState.sections && parsedState.sections.hasOwnProperty(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    if (this.header) this.header.reveal();
    //this.open();
    // Theme add-to-cart flows hit /cart/add.js directly, so refresh the header
    // count from the live cart rather than trusting the Liquid-rendered state.
    const bubble = document.querySelector('cart-icon-bubble');
    if (bubble && typeof bubble.refreshCount === 'function') bubble.refreshCount();

    // Open the Smart Cart, honoring the upsell gate: when an upsell product was
    // added the gate is armed, so this defers instead of opening (the Smart Cart
    // opens later, once the upsell popup is added-to / dismissed).
    window.EH.requestOpenSmartCart();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

/* =========================
   Cart Icon Bubble
   ========================= */

class CartIconBubble extends HTMLElement {
  constructor() {
    super();
    this.onRebuyCartEvent = this.onRebuyCartEvent.bind(this);

    // A manual cart-icon click must escape any armed upsell gate. Otherwise, if a
    // shopper added an upsell product (gate armed, Rebuy skip_open=true) and then
    // clicks the icon, the rebuy:smartcart.show interceptor would immediately
    // re-hide the cart, leaving it stuck closed. Unblock first, then open.
    this.addEventListener('click', (e) => {
      e.preventDefault();
      window.EH.unblockDrawerForRebuy();
      window.EH.openSmartCartNow();
    });

    // The element is not a native <button>, so replicate button keyboard
    // semantics: activate on Enter and Space (and stop Space from scrolling the
    // page). We synthesize a real click() rather than dispatch a custom event so
    // keyboard activation is identical to a mouse click — this is what actually
    // opens the cart, since Rebuy SmartCart binds its own delegated *click*
    // listener to this icon and ignores custom events.
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        this.click();
      }
    });
  }

  connectedCallback() {
    // Ensure the icon is reachable (Tab) and announced as a button even if the
    // markup wasn't updated. header.liquid also sets these; this is defensive.
    if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
    if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
    if (!this.hasAttribute('aria-haspopup')) this.setAttribute('aria-haspopup', 'dialog');

    // Rebuy SmartCart owns the cart, so the header count follows its events.
    document.addEventListener('rebuy:cart.ready', this.onRebuyCartEvent);
    document.addEventListener('rebuy:cart.change', this.onRebuyCartEvent);
  }

  disconnectedCallback() {
    document.removeEventListener('rebuy:cart.ready', this.onRebuyCartEvent);
    document.removeEventListener('rebuy:cart.change', this.onRebuyCartEvent);
  }

  onRebuyCartEvent(event) {
    // Rebuy nests the Shopify cart at detail.cart.cart; fall back to a fetch
    // when an event arrives without it.
    const count = event && event.detail && event.detail.cart && event.detail.cart.cart
      ? event.detail.cart.cart.item_count
      : undefined;

    if (typeof count === 'number') {
      this.setCount(count);
    } else {
      this.refreshCount();
    }
  }

  refreshCount() {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    fetch(`${cartUrl}.js`, { cache: 'no-store' })
      .then((response) => response.json())
      .then((cart) => this.setCount(cart.item_count))
      .catch((e) => console.error(e));
  }

  setCount(count) {
    const bubble = this.querySelector('.cart-count-bubble');
    if (!bubble) return;

    // Leaving it empty lets base.css's `.cart-count-bubble:empty` hide the badge.
    bubble.innerHTML =
      count > 0 && count < 100 ? `<span aria-hidden="true">${count}</span>` : '';
  }
}

customElements.define('cart-icon-bubble', CartIconBubble);
